import _ from 'lodash';
import {Component, Input, OnDestroy, OnInit } from '@angular/core';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {Subject} from 'rxjs';
import {Store} from '@ngrx/store';
import {CampaignService} from '../../../campaign/services/campaign.service';
import {DialogService} from '../../../dialog/services/dialog.service';
import {moveItemInArray} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-event-page-slides-list',
  templateUrl: './event-page-slides-list.component.html',
  styleUrls: ['./event-page-slides-list.component.scss']
})
export class EventPageSlidesListComponent implements OnInit, OnDestroy {
  @Input() slideForm: UntypedFormGroup = null;

  public slides: UntypedFormArray = null;
  public takeUntilSubject: Subject<any> = new Subject()

  constructor(
    public store: Store,
    public formBuilder: UntypedFormBuilder,
    public campaignService: CampaignService,
    public dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.slides = this.slideForm.get('slides') as UntypedFormArray;
  }

  ngOnDestroy() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

  dropOption(event) {
    moveItemInArray(this.slides.controls, event.previousIndex, event.currentIndex);
    this.slides.updateValueAndValidity()
  }

  removeOption(index) {
    this.slides.removeAt(index);
  }

  getPresetOptionImageUrl(option) {
    return _.isEqual(option.value.imageUrl, '/images/blank_2x1.png') || _.isEqual(option.value.imageUrl, '') ?
      "/images/org_logo_default_v2.svg": option.value.imageUrl;
  }
}
